class GiftWrap extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.onCartPage) {
      this.sections = window.BAO.sectionRenderer.cartSections
    }

    if (!this.onCartPage) {
      this.prePopulateSelections()
    }
  }

  setupListeners () {
    this.handleChange = this.handleChange.bind(this)
    this.handleApply = this.handleApply.bind(this)
    this.handleRadio = this.handleRadio.bind(this)

    if (this.els?.textarea?.element) {
      this.listeners.add(this.els.textarea.element, 'input', this.handleChange)
    }

    if (this.els?.apply?.element) {
      this.listeners.add(this.els.apply.element, 'click', this.handleApply)
    }

    if (this.els?.radio?.elements) {
      this.els.radio.elements.forEach((radioEl) => {
        this.listeners.add(radioEl, 'change', this.handleRadio)
      })
    }
  }

  prePopulateSelections () {
    // Get saved gift wrapping value from parent form
    const savedGiftWrapping = this.externalEls?.giftwrapping?.elements.find(
      (el) => el.dataset.formId === this.formId,
    )?.value

    // Get saved gift message from parent form
    const savedGiftMessage = this.externalEls?.giftmessage?.elements.find(
      (el) => el.dataset.formId === this.formId,
    )?.value

    // Pre-select radio button if value exists
    if (savedGiftWrapping) {
      const matchingRadio = this.els?.radio?.elements.find(
        (el) => el.value === savedGiftWrapping,
      )
      if (matchingRadio) {
        this.els.radio.elements.forEach((el) => {
          el.checked = el === matchingRadio
        })
      }
    }

    // Pre-fill message textarea if value exists
    if (savedGiftMessage && this.els?.textarea?.element) {
      this.els.textarea.element.value = savedGiftMessage
      // Update character count
      const count = savedGiftMessage.length
      if (this.els?.count?.element) {
        this.els.count.element.innerHTML = count
      }
    } else if (this.els?.textarea?.element) {
      // Initialize count for empty textarea
      const currentValue = this.els.textarea.element.value.trim()
      if (this.els?.count?.element) {
        this.els.count.element.innerHTML = currentValue.length
      }
    }
  }

  handleChange () {
    const count = this.els?.textarea?.element?.value?.length || 0
    if (this.els?.count?.element) {
      this.els.count.element.innerHTML = count
    }
  }

  async handleApply () {
    const giftMessage = this.els?.textarea?.element?.value || ''

    if (this.onCartPage) {
      const giftwrappingChoice = this.els.radio.elements.find(
        (el) => el.checked,
      )

      this.cart.loading = true

      const cartObj = await BAO.Cart.getCart()
      const currentProperties = cartObj.items.find(
        (item) => item.key === this.getAttribute('data-key'),
      ).properties
      const currentQuantity = cartObj.items.find(
        (item) => item.key === this.getAttribute('data-key'),
      ).quantity

      if (giftwrappingChoice) {
        currentProperties[window.theme.properties.giftWrapping] =
          giftwrappingChoice?.value
      }

      if (giftMessage) {
        currentProperties[window.theme.properties.giftMessage] = giftMessage
      } else {
        delete currentProperties[window.theme.properties.giftMessage]
      }

      const currentWrappingProduct = cartObj.items.find(
        (item) =>
          item.properties._giftwrap_parent_product ===
          parseInt(this.getAttribute('data-variant-id')),
      )
      if (currentWrappingProduct) {
        await window.BAO.Cart.removeItem(currentWrappingProduct.key, {
          sections: [],
        })
      }

      const giftWrapVariantId = giftwrappingChoice?.dataset.productVariantId
      if (giftWrapVariantId) {
        await window.BAO.Cart.cartAdd({
          items: [
            {
              quantity: 1,
              id: giftwrappingChoice.dataset.productVariantId,
              properties: {
                _giftwrap_parent_product: parseInt(
                  this.getAttribute('data-variant-id'),
                ),
              },
            },
          ],
        })
      }

      const state = await window.BAO.Cart.updateItemProperties(
        this.getAttribute('data-key'),
        currentQuantity,
        currentProperties,
        { sections: this.mappedSections },
      )

      this.cart.loading = false

      if ('sections' in state) this.renderSections(state.sections)
    } else {
      // Update gift message in external form
      this.externalEls?.giftmessage?.elements?.forEach((giftmessageEl) => {
        if (giftmessageEl.dataset.formId === this.formId) {
          giftmessageEl.value = giftMessage
          if (giftMessage === '') {
            giftmessageEl.setAttribute('disabled', '')
          } else {
            giftmessageEl.removeAttribute('disabled')
          }
        }
      })

      // Update message status label (if it exists - may not exist in quickbuy)
      this.externalEls?.messagestatus?.elements?.forEach((messagestatusEl) => {
        if (messagestatusEl.dataset.formId === this.formId) {
          messagestatusEl.innerText = messagestatusEl.dataset.add
        } else {
          messagestatusEl.innerText = messagestatusEl.dataset.edit
        }
      })
    }
  }

  handleRadio (event) {
    // Get the radio input that triggered the change event
    const radioEl = event.target

    if (!radioEl) {
      return
    }

    // Get the radio group name
    const radioName = radioEl.getAttribute('name')

    if (!radioName) {
      return
    }

    // Find ALL radios with this name directly from the DOM
    const allRadiosInGroup = this.querySelectorAll(
      `input[type="radio"][name="${radioName}"]`,
    )

    // Ensure all radios in this group are unchecked first
    allRadiosInGroup.forEach((tempEl) => {
      tempEl.checked = false
      tempEl.removeAttribute('checked')
    })

    // Ensure the selected radio is checked
    radioEl.checked = true
    radioEl.setAttribute('checked', '')

    if (!this.onCartPage) {
      // Update the hidden input value in the parent form
      this.externalEls?.giftwrapping?.elements?.forEach((giftwrappingEl) => {
        if (giftwrappingEl.dataset.formId === this.formId) {
          giftwrappingEl.value = radioEl.value
        }
      })

      // Update the trigger label text
      this.externalEls?.triggerlabel?.elements?.forEach((triggerlabelEl) => {
        if (triggerlabelEl.dataset.formId === this.formId) {
          triggerlabelEl.innerText = radioEl.value
          triggerlabelEl.classList.remove('prd-Form_VariantText-light')
        }
      })
    }
  }

  get mappedSections () {
    return this.sections.map((s) => s.section)
  }

  get cart () {
    return this.closest('cart-item')
  }

  get onCartPage () {
    return this.cart != null
  }

  get formId () {
    return this.dataset.formId
  }
}

if (!customElements.get('gift-wrap')) {
  customElements.define('gift-wrap', GiftWrap)
}
